export default __webpack_public_path__ + "83517da9e6f4c3ff216b74c30e44ee9d.svg";